import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import FounderInfo from "../components/FounderInfo";
import LicenseTypes from "../components/LicenseTypes";
import Process from "../components/ServiceSection/Process";
import LatestNews from "../components/NewsSection/LatestNews";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import WhatsAppChat from "../components/WhatsAppChat";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <AboutUs/>
      <FounderInfo/>
      <LicenseTypes/>
      <Process/>
      <LatestNews/>
      <ContactUs/>
      <Footer/>
      <WhatsAppChat/>
    </div>
  )
}

export default Home;
